export default __webpack_public_path__ + "static/media/icone-facebook.9f580ea5.svg";